import React, { useEffect, useState } from "react";
import { FiInstagram } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import TimyaLogo from "../../assets/timya-logo.png";
import data from "../services";
import "./Header.css";

const Header = ({ headerRefIndex }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 15);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleTabClick = (index) => {
    switch (index) {
      case 0: // Anasayfa
        if (pathname === '/') {
          headerRefIndex?.(0);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          navigate('/');
        }
        break;
      case 1: // Odalarımız
        navigate('/odalar');
        break;
      case 2: // Hakkımızda
        navigate('/hakkimizda');
        break;
      case 3: // Galeri
        if (pathname === '/') {
          headerRefIndex?.(3);
        } else {
          navigate('/?scroll=gallery');
        }
        break;
      case 4: // İletişim
        navigate('/iletisim');
        break;
      default:
        headerRefIndex?.(index);
    }
  };

  return (
    <div className={`header-container ${!isScrolled  ? 'header-transparent' : ''}`}>
      <div 
        className="name-row" 
        onClick={() => handleTabClick(0)}
        style={{ cursor: 'pointer' }}
      >
        <img src={TimyaLogo} className="timya-image" alt="Timya Otel Logo" />
      </div>

      <nav className="header-title-container">
        {data.tabs.map((item, index) => (
          <div className="header-title-row" key={index}>
            <button
              className={ "header-title"}
              onClick={() => handleTabClick(index)}
              type="button"
            >
              {item}
            </button>
          </div>
        ))}
      </nav>

      <div className="icon-row">
        <a 
          href="https://www.instagram.com/timyahotel" 
          target="_blank" 
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <FiInstagram className="icon" />
        </a>
      </div>
    </div>
  );
};

export default Header;
